"use client"

import FlagOffer from './Flag'
import ShareOffer from './Share'
// import useMediaQueryBreakpoint from '@hooks/useMediaQueryBreakpoint'
// 800px

function OfferMenu ({  offer, ...rest }) {
    const mobile = true
    return <div style={{alignItems:'center',display:'flex',gap:'12px',justifyContent:(mobile?'space-between':'flex-end'),marginBlock:18}}>
        <FlagOffer mobile={mobile} offer={offer} {...rest} />
        <ShareOffer mobile={mobile} offer={offer} />
    </div>
}
export default OfferMenu